import { useDispatch, useSelector } from "react-redux";
import { MDBModalBody, MDBModalFooter } from "mdb-react-ui-kit";
import { closeSendModal } from "../../../redux/reducer/modalReducer";
import FullModal from "../../../components/modal/full.modal.box";
import ModalHeader from "../../../components/header/modal.header";
import { useToast } from "../../../components/common/common.toast";
import Input from "../../../components/element/input";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import {
  sendPromotion,
  setSendPromotionLoading,
} from "../../../redux/reducer/promotionReducer";
import Select from "../../../components/element/select";
import { getDropdownModel } from "../../../redux/reducer/commonReducer";
import { useEffect } from "react";

export default function SendModal() {
  const toast = useToast();
  const dispatch = useDispatch();

  const { modelOptions } = useSelector((state) => state.common);
  const { promotionList, sendPromotionLoading } = useSelector(
    (state) => state.promotion
  );
  const { isOpenSendModal } = useSelector((state) => state.modal);

  const handleCloseModal = () => {
    dispatch(closeSendModal());
  };

  const customerFormList = [
    {
      placeholder: "Name *",
      name: "customer_name",
      is_required: true,
    },
    {
      placeholder: "Select Car Model",
      name: "car_model",
      component: "dropdown",
    },
    {
      placeholder: "Car Chassis No.",
      name: "chassis",
    },
    {
      name: "phone_number",
      type: "number",
      placeholder: "123456789 *",
      input_classname: "phone_no",
      is_required: true,
    },
    // {
    //   name: "car_plate",
    //   placeholder: "Car Plate No.",
    // },
    {
      name: "register_number",
      placeholder: "Register No.",
    },
  ];

  const promotionForm = {
    voucher_id: isOpenSendModal,
    phone_number: "",
    customer_name: "",
    car_model: "",
    chassis: "",
    // car_plate: "",
    register_number: "",
  };

  const promotionSchema = Yup.object().shape({
    customer_name: Yup.string().required("Name is required"),
    phone_number: Yup.string()
      .matches(/^(11\d{7,8}|1[0-9]\d{7})$/, "Please enter a valid phone number")
      .required("Phone number is required"),
  });

  const promotionInfo = promotionList.find(
    (promotion) => promotion.id === isOpenSendModal
  );

  const handleSubmit = async (values) => {
    dispatch(setSendPromotionLoading(true));

    const formData = new FormData();

    const attachment =
      promotionInfo.media?.length > 0 ? promotionInfo.media[0].api_url : null;

    if (attachment) {
      try {
        const response = await fetch(attachment);
        const blob = await response.blob();
        const file = new File([blob], "attachment.jpg", { type: blob.type });

        formData.append("attachments[0]", file);
      } catch (error) {
        console.error(
          "Error converting promotion image to binary file:",
          error
        );
      }
    }

    formData.append("voucher_id", values.voucher_id);
    formData.append("phone_number", `+60${values.phone_number}`);
    formData.append("customer_name", values.customer_name);
    formData.append("car_model", values.car_model);
    formData.append("chassis", values.chassis);
    // formData.append("car_plate", values.car_plate);
    formData.append("register_number", values.register_number);

    dispatch(sendPromotion({ data: formData }))
      .unwrap()
      .then((res) => {
        dispatch(setSendPromotionLoading(false));
        handleCloseModal();
        toast.success(
          `Send promotion to customer +60${values.phone_number} successfully.`
        );
      })
      .catch((ex) => {
        dispatch(setSendPromotionLoading(false));
        if (ex && ex.response?.status === 422) {
          const errors = ex.response.data.errors;
          if (errors && Object.keys(errors).length > 0) {
            Object.keys(errors).map((item, i) => {
              toast.error(errors[item][0]);
            });
          }
        }
      });
  };

  useEffect(() => {
    dispatch(getDropdownModel());
  }, []);

  return (
    <FullModal
      staticBackdrop={true}
      show={isOpenSendModal !== null}
      backButton={handleCloseModal}
      screenSize="xl"
      className="overflow-hidden"
      dialogClassName="width-440"
      contentClassName="auto"
      content={
        <>
          <ModalHeader
            className="br-34"
            backTo={handleCloseModal}
            title="Send Promotion"
          />
          <Formik
            initialValues={promotionForm}
            validationSchema={promotionSchema}
            enableReinitialize={true}
            onSubmit={(values, { setFieldError }) => {
              handleSubmit(values, setFieldError);
            }}
          >
            {({ values, isValid }) => (
              <Form className="formik-form">
                <MDBModalBody>
                  <article className="send-modal">
                    {customerFormList.map((form, formIndex) => (
                      <article key={formIndex}>
                        {form.component === "dropdown" ? (
                          <Select
                            name={form.name}
                            label={form.label}
                            placeholder={form.placeholder}
                            options={modelOptions}
                            formatGroupLabel={(group) => (
                              <strong>{group.label}</strong>
                            )}
                            className="w-27em"
                          />
                        ) : (
                          <Input
                            as="round-field"
                            type={form.type}
                            inputClassName={form.input_classname}
                            name={form.name}
                            label={form.label}
                            placeholder={form.placeholder}
                            isRequired={form.is_required}
                            errorClassName="mt-2 mb-2"
                            className="w-24em"
                          />
                        )}
                      </article>
                    ))}
                  </article>
                </MDBModalBody>
                <MDBModalFooter className="--bottom-unset p-0">
                  <article
                    className={`footer-button ${
                      !isValid || sendPromotionLoading ? "--disabled" : ""
                    }`}
                    onClick={() => {
                      if (isValid && !sendPromotionLoading) {
                        handleSubmit(values);
                      }
                    }}
                  >
                    <h5>Send</h5>
                  </article>
                </MDBModalFooter>
              </Form>
            )}
          </Formik>
        </>
      }
    />
  );
}
